module.exports = __webpack_public_path__ + "static/media/logo.36691c0a.png";